module.exports = __webpack_public_path__ + "media/assets/Grid-46c1a135d3aaeb3960f0f8a92aeb7ccb.svg";